import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c794aeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "juou-card store-bill-statistic" }
const _hoisted_2 = { class: "store-bill-statistic-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btns" }, null, -1))
const _hoisted_4 = { class: "store-bill-statistic-body" }
const _hoisted_5 = { class: "store-bill-statistic-body-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总收入", -1))
const _hoisted_7 = { class: "store-bill-statistic-body-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总计入账", -1))
const _hoisted_9 = { class: "store-bill-statistic-body-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "押金入账", -1))
const _hoisted_11 = { class: "store-bill-statistic-body-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总退款", -1))
const _hoisted_13 = { class: "store-bill-statistic-body-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "充值套餐", -1))
const _hoisted_15 = { class: "store-bill-statistic-body-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "小时套餐", -1))
const _hoisted_17 = { class: "store-bill-statistic-body-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "美团套餐", -1))
const _hoisted_19 = { class: "store-bill-statistic-body-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "抖音套餐", -1))

import { useBaseUserStore, JuouProForm, JuouProFormItem, useRoute, useBaseAsync, vJuouOperate } from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import defaultImg from '@/assets/store.jpg';
import { ElMessage } from 'element-plus';
import { getCurrentUrl } from '@/utils';
import { cloneDeep } from 'lodash';
import { useStore } from '@/store/store';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

export default /*#__PURE__*/_defineComponent({
  __name: 'StoreBillStatistic',
  emits: ["filter"],
  setup(__props, { expose: __expose, emit: __emit }) {

dayjs.locale('zh-cn');
const emit = __emit;

const filter = ref<JuouProFormItem[]>([]);
const filterRef = ref<InstanceType<typeof JuouProForm>>();

const route = useRoute();


const loading = ref(false);
const statisticLoading = ref(false);

const store = useStore();

const currentTimeRange = ref([dayjs().format('YYYY-MM-DD 00:00:00'), dayjs().format('YYYY-MM-DD 23:59:59')]);

const statistic = ref({
  netPrice: '0',
  allPrice: '0',
  allBackPrice: '0',
  allCashPledgePrice: '0',
  allPayPrice: '0',
  allHourPrice: '0',
  allMeituanPrice: '0',
  allDouyinPrice: '0',
});

const getStatistic = useBaseAsync(async() => {
  if (!store.currentStoreId) {
    return;
  }
  try {
    statisticLoading.value = true;
    const res = await useApi().billApi.statisticBillBill({
      storeId: store.currentStoreId,
      start: currentTimeRange.value[0],
      end: currentTimeRange.value[1],
    });
    console.log(res);
    statistic.value = res.data.data || {};
  } finally {
    statisticLoading.value = false;
  }
});


const handleFilterChange = (data: any) => {
  store.setCurrentStoreId(data.selectStore);
  currentTimeRange.value = data.timeRange;
  getStatistic();
  emit('filter', data);
};


// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    const [storeDetailRes] = await Promise.all([useApi().storeManagerApi.listManagerStoreStoreManager()]);
    const details = storeDetailRes.data.data || [];
    filter.value = [
      {
        name: 'selectStore',
        label: '切换门店',
        type: 'select',
        options: details.map((item: any) => ({
          value: item.id,
          label: item.name,
        })),
        clearable: false,
      },
      {
        name: 'timeRange',
        label: '时间范围',
        type: 'datepick',
        pickType: 'datetimerange',
        fastPick: [
          {
            name: '今日',
            handler: (formdata) => {
              formdata['timeRange'] = [
                dayjs().format('YYYY-MM-DD 00:00:00'),
                dayjs().format('YYYY-MM-DD 23:59:59'),
              ];
            },
            dateChangeHandler: ([start, end]) => {
              const [startDay, startTime] = start.split(' ');
              const [endDay, endTime] = end.split(' ');
              return startDay === endDay && startTime === '00:00:00' && endTime === '23:59:59' && dayjs().format('YYYY-MM-DD') === startDay;
            },
          },
          {
            name: '昨日',
            handler: (formdata) => {
              formdata['timeRange'] = [
                dayjs().subtract(1, 'd')
                  .format('YYYY-MM-DD 00:00:00'),
                dayjs().subtract(1, 'd')
                  .format('YYYY-MM-DD 23:59:59'),
              ];
            },
            dateChangeHandler: ([start, end]) => {
              const [startDay, startTime] = start.split(' ');
              const [endDay, endTime] = end.split(' ');
              return startDay === endDay && startTime === '00:00:00' && endTime === '23:59:59' && dayjs().subtract(1, 'd')
                .format('YYYY-MM-DD') === startDay;
            },
          },
          {
            name: '本周',
            handler: (formdata) => {
              formdata['timeRange'] = [
                dayjs().startOf('week')
                  .format('YYYY-MM-DD 00:00:00'),
                dayjs().format('YYYY-MM-DD 23:59:59'),
              ];
            },
            dateChangeHandler: ([start, end]) => {
              const [startDay, startTime] = start.split(' ');
              const [endDay, endTime] = end.split(' ');
              return dayjs().format('YYYY-MM-DD') === endDay && dayjs(end).startOf('week')
                .format('YYYY-MM-DD') === startDay && startTime === '00:00:00' && endTime === '23:59:59';
            },
          },
          {
            name: '本月',
            handler: (formdata) => {
              formdata['timeRange'] = [
                dayjs().startOf('month')
                  .format('YYYY-MM-DD 00:00:00'),
                dayjs().format('YYYY-MM-DD HH:mm:ss'),
              ];
            },
            dateChangeHandler: ([start, end]) => {
              const [startDay, startTime] = start.split(' ');
              const [endDay, endTime] = end.split(' ');
              return dayjs().format('YYYY-MM-DD') === endDay && dayjs(end).startOf('month')
                .format('YYYY-MM-DD') === startDay && startTime === '00:00:00';
            },
          },
          {
            name: '上月',
            handler: (formdata) => {
              formdata['timeRange'] = [
                dayjs().subtract(1, 'month')
                  .startOf('month')
                  .format('YYYY-MM-DD 00:00:00'),
                dayjs().subtract(1, 'month')
                  .endOf('month')
                  .format('YYYY-MM-DD HH:mm:ss'),
              ];
            },
            dateChangeHandler: ([start, end]) => {
              const [startDay, startTime] = start.split(' ');
              const [endDay, endTime] = end.split(' ');
              return dayjs().subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD') === startDay && dayjs().subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD') === endDay && startTime === '00:00:00' && endTime === '23:59:59';
            },
          },
        ],
      },
    ];
    if (details.length && !details.find((item: any) => item.id === store.currentStoreId)) {
      filterRef.value?.setOneFormState('selectStore', details[0].id);
    }
  } finally {
    loading.value = false;
  }
});


init();

__expose({
  getStatistic,
});


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_unref(JuouProForm), {
          ref_key: "filterRef",
          ref: filterRef,
          items: filter.value,
          "is-inline": "",
          "hide-cancel": "",
          "hide-ok": "",
          onChange: handleFilterChange,
          "init-form-value": { timeRange:  currentTimeRange.value }
        }, null, 8, ["items", "init-form-value"])
      ]),
      _hoisted_3
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.netPrice), 1),
        _hoisted_6
      ]),
      _createVNode(_component_el_divider, {
        style: {"height":"70%"},
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allPrice), 1),
        _hoisted_8
      ]),
      _createVNode(_component_el_divider, {
        style: {"height":"70%"},
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allCashPledgePrice), 1),
        _hoisted_10
      ]),
      _createVNode(_component_el_divider, {
        style: {"height":"70%"},
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allBackPrice), 1),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allPayPrice), 1),
        _hoisted_14
      ]),
      _createVNode(_component_el_divider, {
        style: {"height":"70%"},
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allHourPrice), 1),
        _hoisted_16
      ]),
      _createVNode(_component_el_divider, {
        style: {"height":"70%"},
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allMeituanPrice), 1),
        _hoisted_18
      ]),
      _createVNode(_component_el_divider, {
        style: {"height":"70%"},
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("span", null, "￥" + _toDisplayString(statistic.value.allDouyinPrice), 1),
        _hoisted_20
      ])
    ])), [
      [_directive_loading, statisticLoading.value]
    ])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})